import React from 'react'
import { Container } from 'react-bootstrap'
import Logo from '../../assets/images/alphastar-academy-logo.svg'
import Icon from '../../assets/images/alphastar-academy-icon.svg'

const Layout = ({ children }) => {
  return (
    <div className='main-wrapper animated'>
      <Container className='h-100'>
        <div className='header text-center mt-3'>
          <a href='https://alphastar.academy/' target='_blank' rel='noreferrer'>
            <img src={Logo} alt='AlphaStar Academy' width='200' height='62' />
          </a>
        </div>
        {children}
        <div className='footer text-center mb-3'>
          <img src={Icon} alt='AlphaStar Academy' width='48' height='36' />
          <span>© 2021 - AlphaStar Academy</span>
          <a
            href='https://docs.google.com/forms/d/e/1FAIpQLSeLs2WewduVFvwApj9IyMunIEUvX1HiwNoOrmDXVOV3efMNnA/viewform?entry.550535640=Basic4'
            target='_blank'
            rel='noreferrer'
            className='ms-3'
          >
            Leave Us Feedback
          </a>
        </div>
      </Container>
    </div>
  )
}

export default Layout
